import React, { ReactNode } from 'react';
import { Divider } from '@material-ui/core';
import Loader from './CustomLoader';
import AnimatedLoader from '../../components/display/AnimatedLoader';

interface IScreenProps {
    useAnimatedLoader ?: boolean;
    isPadded ?: boolean;
    isScrollable ?: boolean;
    actions ?: ReactNode;
    isLoading ?: boolean;
    backgroundColor ?: string;
    children ?: React.ReactNode;
}

/**
 * @param {boolean} isPadded - Adds padding around screen content if true. Optional.
 * @param {boolean} isScrollable - Allows the screen content to scroll if true. Optional.
 * @param {React.ReactNode} actions - UI elements like buttons or toolbars related to screen content. Optional.
 * @param {boolean} isLoading - Shows a loading indicator if the screen is loading. Optional.
 * @param {string} backgroundColor - Background color of the screen, accepts any valid CSS color. Optional.
 * @param {React.ReactNode} children - Children elements to be rendered within the screen. Optional.
 *
 * @return {React.ReactElement} The React element for the Screen component.
 */
const Screen = (props : IScreenProps) : React.ReactElement => {
    const {
        useAnimatedLoader = false,
        isLoading = false,
        isPadded = true,
        isScrollable = true,
        actions,
        backgroundColor = 'bcg0',
        children,
    } = props;

    return (
        <div className={`hfill flx1 oxh fdc posr ${backgroundColor}`}>
            {
                isLoading && (useAnimatedLoader ? <AnimatedLoader /> : <Loader />)
            }
            <div className={`hfill flx1 fdc ${isPadded ? 'p20 pb10' : ''} ${isScrollable ? 'oys' : ''}`}>
                {children}
            </div>
            {!!actions && <Divider />}
            <div>{actions}</div>
        </div>
    );
};

export default Screen;
